import React, {Component} from 'react';
import ExpandableLI from 'components/expandableLI';
import {isMobile, isTablet, imageUrl} from 'helpers/ApplicationHelper';

class HIWsection extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            isTablet: false
        };
    }

    componentDidMount() {
        this.setState({
            isMobile: isMobile(),
            isTablet: isTablet()
        });
    }

    render() {
        const orientation = this.props.section.config? this.props.section.config.reverseOrientation : false;
        const style = {
            backgroundColor: this.props.section.config? this.props.section.config.backgroundColor : 'white'
        }
        let bgPicStyle = {
            transform: this.props.section.config.phantomOffset,
            opacity: this.props.section.config.opacity || 1
        };
        if(this.state.isMobile){bgPicStyle.left = `calc(100% - 200px)`;}
        else {bgPicStyle[orientation? 'right' : 'left'] = `calc(100% - 400px)`}
        return (
        <div className='step-section-container' style={style}>
            <div ref={this.props.inref} className={"step-section"+ (orientation? ' reverse-orientation' : '')}>
                <div className="step-content">
                    <span className="step-num">{this.props.section.stepNum}</span>
                    <hr className="numUnderline"/>
                    <h2 className="step-title" dangerouslySetInnerHTML={{__html:this.props.section.title}}/>
                    <p className="step-subtitle">{this.props.section.subtitle}</p>
                    <ul className="step-LIs">
                        {this.props.section.stepListItems.map((listItem,i) =>{
                            const hr = (i === this.props.section.stepListItems.length-1) ? '' : <hr/>;
                            return (
                            <React.Fragment key={i}>
                                <ExpandableLI expandText={listItem.expandText} bullet={listItem.bullet}/> 
                                {hr}
                            </React.Fragment>
                            )
                        })}
                    </ul>
                </div>
                <div className="place-holder"/>
            </div>
            <div className='bg-img-container'>
                <img className='bg-img' style={bgPicStyle} src={imageUrl(this.props.section.config.phantomBackground)} alt=""/>
            </div>    
        </div>
        );
    }
}   

export default HIWsection;